import {delegateListener} from '../utils/delegate-listener.js';

const setAccordion = () => {
  const accordionSelector = '.accordion-header';

  delegateListener('click', accordionSelector, e => {
    e.preventDefault();
    const header = e.target.closest(accordionSelector);
    const content = header.nextElementSibling;
    if (!header || !content) return;
    header.classList.toggle('expanded');
    content.style.height =
        content.clientHeight ? 0 : content.scrollHeight + 'px';
  });

  document.querySelectorAll('.accordion-header.expanded').forEach(header => 
      setAccordionExpanded(header));
};

const setAccordionExpanded = (header) => {
  const content = header.nextElementSibling;
  if (!content) return;
  content.style.height = content.scrollHeight + 'px';
};

export {setAccordion};